import {createDefaultLogger} from '@hconnect/common/logging'

/**
 * This is an instance of the cross-product logger specifically for HCEM
 */
export const Log = createDefaultLogger('hcem')
